/**
 * @description 账户模块
 */
export default [
    {
        path: "/account/login/password", //密码登录
        name: "account__password_login",
        component: () => import("@/views/account/PasswordLogin.vue"),
        meta: {
            title: "密码登录-油柑网",
            requiresAuth: false,
        },
    },
    {
        path: "/account/login/code", //验证码登录
        name: "account_code_login",
        component: () => import("@/views/account/CodeLogin.vue"),
        meta: {
            title: "验证码登录-油柑网",
            requiresAuth: false,
        },
    },
    {
        path: "/account/login/wechat", //微信登录
        name: "account_wechat_login",
        component: () => import("@/views/account/WechatLogin.vue"),
        meta: {
            title: "微信登录-油柑网",
            requiresAuth: false,
        },
    },
    {
        path: "/account/register", //注册
        name: "account_register",
        component: () => import("@/views/account/Register.vue"),
        meta: {
            title: "注册-油柑网",
            requiresAuth: false,
            bodyColor: true,
        },
    },
    {
        path: "/account/find/password", //找回密码
        name: "account_find_password",
        component: () => import("@/views/account/FindPassword.vue"),
        meta: {
            title: "找回密码-油柑网",
            requiresAuth: false,
            bodyColor: true,
        },
    },
    {
        path: "/account/change/password", //修改密码
        name: "account_change_password",
        component: () => import("@/views/account/ChangePassword.vue"),
        meta: {
            title: "修改密码-油柑网",
            requiresAuth: false,
            bodyColor: true,
        },
    },
    {
        path: "/account/bind/phone", //关联账户
        name: "account_bind_phone",
        component: () => import("@/views/account/BindPhone.vue"),
        meta: {
            title: "关联账户-油柑网",
            requiresAuth: false,
            bodyColor: true,
        },
    },
    {
        path: "/account/bind/phone/password", //绑定手机设置密码
        name: "account_bind_phone_password",
        component: () => import("@/views/account/BindPhone_Password.vue"),
        meta: {
            title: "绑定手机-油柑网",
            requiresAuth: false,
            bodyColor: true,
        },
    },
    {
        path: "/account/set/password", //设置密码
        name: "account_set_password",
        component: () => import("@/views/account/SetPassword.vue"),
        meta: {
            title: "设置密码-油柑网",
            requiresAuth: false,
            bodyColor: true,
        },
    },
    {
        path: "/account/invite/register", //邀请注册
        name: "account_invite_register",
        component: () => import("@/views/account/Invite_Register.vue"),
        meta: {
            title: "邀请注册-油柑网",
            bodyColor: true,
        },
    },
    {
        path: "/account/register/success", //设置密码
        name: "account_register_success",
        component: () => import("@/views/account/Register_Success.vue"),
        meta: {
            title: "注册成功-油柑网",
            bodyColor: true,
        },
    },
];
